<template>
   <v-tooltip color="secondary" bottom>
      <template v-slot:activator="{ on }">
        <v-avatar
          v-on="on"
          v-if="avatarOnly"
          color="secondary"
          class="status secondary--gradient"
          :class="{ sleeping: isSleeping, active: isActive, 'logged-out': isLoggedOut }"
          size="40">
          <span style="color:white; font-weight:300" class="initials" :title="name">{{initials}}</span>
        </v-avatar>
        </template>
        <span>User name needs to go in here</span>
      </v-tooltip>
</template>
<script>
export default {
  name: "UserAvatarCase",
  props: {
    name: { type: String, required: true },
    userId: { type: Number },
    avatarURL: String,
    status: String,
    lastSeen: String,
    size: { type: String, default: "32px" },
    displayAdd: { type: Boolean, default: false },
    displayCancel: { ype: Boolean, default: false },
    avatarOnly: { type: Boolean, default: false }
  },
  computed: {
    urlPresent: function() { return !!this.avatarURL },
    initials: function() {
      if (this.name) {
        if (this.name.length > 2) {
          const nameParts = this.name.split(" ")
          if (nameParts.length === 1) {
            return nameParts[0].substring(0, 1)
          }
          if (nameParts.length >= 2) {
            return nameParts[0].substring(0, 1) + nameParts[1].substring(0, 1)
          }
        } else {
          return this.name
        }
      }
      return ""
    },
    isSleeping: function() { return this.status === "sleeping" },
    isActive: function() { return this.status === "active" },
    isLoggedOut: function() { return this.status === "loggedOut" },
    isButtonUsed: function() { return !(this.displayCancel || this.displayAdd) }
  },

  methods: {
    clickedAdd() {
      this.$emit("clickedAdd", {
        user: { id: this.userId, displayName: this.name },
        type: "user"
      })
    },
    clickedRemove() {
      this.$emit("clickedRemove", {
        user: { id: this.userId, displayName: this.name },
        type: "user"
      })
    }
  }
}
</script>

